module.exports = __webpack_public_path__ + "static/media/Y-Ship-Cloud-Operation-Manual.bad27e53.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/Y-Ship-Cloud-Operation-Manual.pdf
// module id = 812
// module chunks = 0